<template>
  <div class="employee-dropdown" v-click-outside="closeDropdown">
    <div class="dropdown-container">
      <div class="dropdown-header" @click="toggleDropdown" :class="{ disabled }">
        <div style="display: flex; align-items: center; gap: 8px">
          <div
            v-if="selectedItem"
            style="margin-top:3px; display:flex; align-items: center; gap:6px"
          >
            <img
              :src="selectedItem.profile_picture || 'static/img/default-dp.png'"
              class="avatar"
            />
            <div class="status">
              <span class=" user-name">{{ selectedItem[labelKey] }}</span>            </div>
          </div>

          <div v-else>
            <i class="fa fa-user" style="font-size:18px; margin-right: 5px" ></i>
           <span >{{ placeholder }}</span> 
          </div>
        </div>

        <div style=" color: #7b7a7ac7; margin-right: 0px;  font-size:14px"
        >
          <i  :class="['fa  ', dropdownOpen ? 'fa-chevron-up'  : 'fa-chevron-down']"></i>
        </div>
      </div>

      <div v-if="dropdownOpen" class="dropdown-body">
        <div class="filter-options">
          <div
            class="filter-item"
            :class="{ active: filterType === 'all' }"
            @click.stop="setFilter('all')"
          >
            <span>
              <i class="fa fa-users" style="font-size: 16px"></i>
              <span class="filter">All Employees</span>
            </span>
            <span class="count">{{ items.length }}</span>
          </div>

          <div
            class="filter-item"
            :class="{ active: filterType === 'active' }"
            @click.stop="setFilter('active')"
          >
            <span>
              <i class="fa fa-user-check" style="font-size: 16px"></i>
              <span class="filter">Active Employees</span>
            </span>
            <span class="count">{{ activeItems.length }}</span>
          </div>
        </div>

        <!-- Search -->
        <input
          v-if="searchable"
          v-model="searchQuery"
          type="text"
          class="search-box"
          placeholder="Search employees..."
        />

        <!-- Employee list -->
        <ul class="employee-list">
          <li
            v-for="emp in filteredItems"
            :key="emp.uid"
            @click="selectItem(emp)"
            class="employee-item"
          >
          <div class="item">
            <img
              :src="emp.profile_picture || 'static/img/default-dp.png'"
              class="avatar"
            />
            <div class="status">
              <span class="user-name">{{ emp[labelKey] }}</span>
              <span class="small" v-if="!emp.isActive">(inactive)</span>
            </div>
            </div>
            <i
              v-if="selectedItem && selectedItem.uid === emp.uid"
              class="fa fa-check"
              style="color: green; margin-left: auto"
            ></i>
      
          </li>
          
        </ul>

        <!-- Empty -->
        <div
          v-if="filteredItems.length === 0"
          class="custom-searchable-dropdown-item empty"
        >
          No matching items found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderEmployeeDropdown",
  props: {
    items: { type: Array, required: true },
    labelKey: { type: String, default: "username" },
    searchable: { type: Boolean, default: true },
    placeholder: { type: String, default: "Select Employee" },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      dropdownOpen: false,
      searchQuery: "",
      selectedItem: null,
      filterType: "active", // default filter
    };
  },
  computed: {
    activeItems() {
      return this.items.filter((u) => u.isActive);
    },
    filteredItems() {
      let list =
        this.filterType === "active" ? this.activeItems : this.items;

      if (this.searchQuery) {
        const term = this.searchQuery.toLowerCase();
        list = list.filter(
          (u) =>
            (u[this.labelKey] &&
              u[this.labelKey].toLowerCase().includes(term)) ||
            (u.email && u.email.toLowerCase().includes(term))
        );
      }

      return list;
    },
  },
  methods: {
    toggleDropdown() {
      if (!this.disabled) this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    selectItem(item) {
      this.selectedItem = item;
      this.$emit("select", item);
      this.closeDropdown();
    },
    clearSelection() {
      this.selectedItem = null;
      this.searchQuery = "";
      this.$emit("select", null);
      this.closeDropdown();
    },
    setFilter(type) {
      this.filterType = type;
    },
  },
};
</script>

<style scoped>
.employee-dropdown {
  font-size: 16px;
  color: #0000;
  font-weight: 400 !important;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif !important;
}
.dropdown-container {
  position: absolute;
  z-index: 90;
  width: 260px;
  color: #000000 !important;
}
.dropdown-header {
  border-bottom: 1px solid #777777 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px;
  cursor: pointer;
  font-size: 15px;
  height: 45px;
  font-size: 16px;
  color: #000000 !important;
  gap: 8px;
  font-weight : 400 !important;
  min-width: 210px;
}
.dropdown-header.disabled {
  opacity: 0.6;
  cursor: normal !important; 
}
.dropdown-body {
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  background: white;
  margin-top: 5px;
  padding: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.filter-options {
  display: flex;
  flex-direction: column;
}
.filter-item {
  padding: 8px 12px;
  cursor: pointer;
  height: 42px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
}
.filter{
    margin-left: 5px;
}
.filter-item.active {
  background: #f0f9f7;
}
.search-box {
  width: 100%;
  padding: 8px;
  border: none;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  outline: none;
  font-size: 13px;
  height: 42px;
}
.employee-list {
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
}
.employee-item {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0px 8px;
  padding-top: 13px;
  cursor: pointer;
  gap: 10px;
  height: 48px;
}
.item{
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 15px;
  gap: 10px;

}
.employee-item:hover {
  background: #f9f9f9;
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.status {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-left: 10px;
  gap: 8px;
}
.small {
  font-size: 8px;
  margin-top: -5px
}
.count {
  background: #5ec1a6;
  color: white;
  font-size: 8px;
  min-width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  border-radius: 12px;
}
.icons{
  display: flex; 
  gap: 7px; 
  align-items: center;
  font-size: 14px;
  color: #555 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/HeaderEmployeeDropdown.vue